<template>
  <div class="container">
    <!-- 顶部筛选栏 -->
    <div style="display: flex; justify-content: space-between; flex-wrap: wrap">
      <div
        style="display: flex; align-items: center; gap: 10px; flex-wrap: wrap"
      >
        <!-- 关键字搜索 -->
        <el-input
          v-model="keyword"
          style="width: 200px"
          placeholder="请输入学校/学生/老师名称"
          clearable
          @clear="getTableList"
        >
        </el-input>

        <!-- [新增] 学校类型筛选 -->
        <el-select
          v-model="schoolType"
          placeholder="学校类型"
          clearable
          style="width: 120px"
          @change="getTableList"
        >
          <el-option label="小学组" :value="0"></el-option>
          <el-option label="中学组" :value="1"></el-option>
        </el-select>

        <!-- [新增] 审核状态筛选 -->
        <el-select
          v-model="status"
          placeholder="审核状态"
          clearable
          style="width: 120px"
          @change="getTableList"
        >
          <el-option label="待审核" :value="0"></el-option>
          <el-option label="通过" :value="1"></el-option>
          <el-option label="未通过" :value="2"></el-option>
        </el-select>

        <el-button type="primary" icon="el-icon-search" @click="handleSearch"
          >查询</el-button
        >
      </div>
      <!-- <div>
                <el-button type="primary" style="margin-left: 20px;">导出报名表</el-button>
            </div> -->
    </div>

    <!-- table -->
    <div style="margin-top: 20px">
      <el-table
        :data="tableList"
        v-loading="dataListLoading"
        style="width: 1490px"
        height="600"
      >
        <el-table-column
          label="序号"
          width="50"
          type="index"
          header-align="center"
          align="center"
          fixed="left"
        ></el-table-column>
        <el-table-column
          v-for="(item, key) in columns"
          :key="key"
          :width="item.width || 'auto'"
          align="center"
          :label="item.label"
        >
          <template slot-scope="scope">
            <div v-if="!item.slot">{{ scope.row[item.prop] }}</div>
            <div v-else>
              <div v-if="item.prop === 'applyUrl'">
                <a :href="scope.row[item.prop]" target="_blank">点击查看</a>
              </div>
              <div v-if="item.prop === 'auditStatus'">
                <el-tag
                  :type="
                    scope.row[item.prop] === 1
                      ? 'success'
                      : scope.row[item.prop] === 2
                      ? 'error'
                      : 'warning'
                  "
                >
                  {{
                    scope.row[item.prop] === 1
                      ? "通过"
                      : scope.row[item.prop] === 2
                      ? "未通过"
                      : "待审核"
                  }}
                </el-tag>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="学校论文"
          header-align="center"
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.reportUrl"
              type="text"
              size="small"
              :disabled="
                userId == 4 ? false : scope.row.userId !== userId ? true : false
              "
              @click="handleClick(scope.row, 1)"
            >
              查看论文
            </el-button>
            <el-upload
              ref="fileUploadBtn"
              class="upload-demo"
              :show-file-list="false"
              :action="action"
              accept=".pdf,.doc,.docx"
              multiple
              :limit="1"
              :before-upload="handleBefore"
              :on-success="hanleSuccess"
            >
              <el-button
                type="text"
                size="small"
                :disabled="
                  userId == 4
                    ? false
                    : scope.row.userId !== userId
                    ? true
                    : false
                "
                @click="handleClick(scope.row, 2)"
                >上传论文</el-button
              >
            </el-upload>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          fixed="right"
          v-if="type === 9"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="goShenhe(scope.row)"
              :disabled="scope.row.auditStatus === 1"
            >
              审核
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div style="margin-top: 20px">
      <el-pagination
        layout="prev, pager, next"
        :total="total"
        :current-page.sync="pageNum"
        :page-size="pageSize"
        @current-change="currentChange"
        @prev-click="prevClick"
        @next-click="nextClick"
      >
      </el-pagination>
    </div>
    <auditVue ref="audit" />
  </div>
</template>

<script>
import { $activity } from "@/services";
import { BASE } from "@/services/base";
import auditVue from "./components/audit.vue";
import { mapGetters, mapState } from "vuex";

export default {
  components: {
    auditVue,
  },
  data() {
    return {
      columns: [
        { prop: "schoolName", label: "学校名称", width: "200" },
        { prop: "province", label: "省份" },
        { prop: "address", label: "详细地址", width: "200" },
        { prop: "teacher1", label: "指导老师1" },
        { prop: "teacher1Contact", label: "电话" },
        { prop: "teacher2", label: "指导老师2" },
        { prop: "teacher2Contact", label: "电话" },
        { prop: "studentName", label: "学生" },
        { prop: "applyUrl", label: "报名表", slot: true },
        { prop: "auditStatus", label: "审核状态", slot: true },
        { prop: "auditOpinion", label: "审核意见" },
        { prop: "remark", label: "备注" },
      ],
      dataListLoading: false,
      tableList: [],
      pageNum: 1,
      pageSize: 10,
      keyword: "",
      // [新增] 筛选参数
      schoolType: "", // 学校类型: 0小学 1初中
      status: "", // 审核状态: 0未审核 1通过 2驳回

      total: 0,
      action: BASE + "/server/common/upload",
      id: "",
    };
  },
  computed: {
    ...mapGetters("match", ["currentMatchVersion"]),
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      userId: (state) => state.user.userInfo?.id,
      type: (state) => state.user.userInfo?.type,
    }),
  },
  created() {
    const userInfo = this.userInfo;
    if (!userInfo || !userInfo.id) {
      this.$message.error("您尚未登录，请先登录");
      this.$router.push({
        name: "login",
        query: { redirect: this.$route.fullPath },
      });
      return;
    }
    this.$store.dispatch("match/fetchMatchVersionList");
    this.getTableList();
  },
  methods: {
    // [新增] 点击查询按钮时，重置页码为1
    handleSearch() {
      this.pageNum = 1;
      this.getTableList();
    },
    async getTableList() {
      if (!this.currentMatchVersion) {
        setTimeout(this.getTableList, 200);
        return;
      }

      if (!this.dataListLoading) {
        this.dataListLoading = true;
        let params = {};
        params.pageNum = this.pageNum;
        params.pageSize = this.pageSize;
        params.keyword = this.keyword;
        params.userId = this.userId;
        params.matchVersion = this.currentMatchVersion;

        // [新增] 传入筛选参数
        // 注意: 只有当值不为空字符串/null/undefined时才传, 0 是有效值
        if (this.schoolType !== "" && this.schoolType !== null) {
          params.schoolType = this.schoolType;
        }
        if (this.status !== "" && this.status !== null) {
          params.status = this.status;
        }

        try {
          let res = await $activity.signList(params);
          if (res.code === 200) {
            this.total = res.data.total;
            this.tableList = res.data.records;
          }
        } catch (error) {
          console.error("获取报名列表失败:", error);
        } finally {
          this.dataListLoading = false;
        }
      }
    },
    currentChange(e) {
      this.pageNum = e;
      this.getTableList();
    },
    prevClick(e) {
      this.pageNum = e;
      this.getTableList();
    },
    nextClick(e) {
      this.pageNum = e;
      this.getTableList();
    },
    async handleBefore(file) {
      if (file.size / 1024 / 1024 > 5) {
        this.$message.error("上传论文不能大于5M");
        this.fileList = [];
        return false;
      }
    },
    hanleSuccess(response) {
      if (response.code === 200) {
        if (!this.currentMatchVersion) {
          this.$message.error("未获取到届数信息, 上传失败");
          return;
        }

        let params = {};
        params.id = this.id;
        params.reportUrl = response.data.url;
        params.matchVersion = this.currentMatchVersion;

        $activity
          .reportLunwen(params)
          .then((res) => {
            if (res.code === 200) {
              this.$message.success("上传成功");
              this.$refs.fileUploadBtn.clearFiles();
              this.getTableList();
            } else {
              this.$message.error("系统错误,请联系管理员");
              this.$refs.fileUploadBtn.clearFiles();
            }
          })
          .catch(() => {
            this.$refs.fileUploadBtn.clearFiles();
            this.$message.error("系统错误,请联系管理员");
          });
      }
    },
    async handleClick(row, index) {
      if (!this.currentMatchVersion) {
        this.$message.error("未获取到届数信息, 操作失败");
        return;
      }
      if (index === 1) {
        window.open(row.reportUrl, "_blank");
      } else {
        this.id = row.id;
      }
    },
    goShenhe(row) {
      this.$refs.audit.setFlag(row, this.currentMatchVersion);
    },
  },
  watch: {
    currentMatchVersion(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.handleSearch(); // 切换届数时，重置页码并查询
      }
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  padding: 40px;
}
</style>